const POST_OAUTH_REDIRECT_STORAGE_KEY = 'tbyt_post_oauth_redirect';

const isBrowser = typeof window !== 'undefined';

const normalizeRelativePath = (path: string): string | null => {
  if (!path) {
    return null;
  }

  if (path.startsWith('/')) {
    return path;
  }

  if (!isBrowser) {
    return null;
  }

  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const setPostOAuthRedirect = (path: string): void => {
  if (!isBrowser) {
    return;
  }

  const normalizedPath = normalizeRelativePath(path);
  if (!normalizedPath) {
    return;
  }

  sessionStorage.setItem(POST_OAUTH_REDIRECT_STORAGE_KEY, normalizedPath);
};

export const getPostOAuthRedirect = (): string | null => {
  if (!isBrowser) {
    return null;
  }

  const storedPath = sessionStorage.getItem(POST_OAUTH_REDIRECT_STORAGE_KEY);
  return storedPath ? normalizeRelativePath(storedPath) : null;
};

export const clearPostOAuthRedirect = (): void => {
  if (!isBrowser) {
    return;
  }

  sessionStorage.removeItem(POST_OAUTH_REDIRECT_STORAGE_KEY);
};

export const consumePostOAuthRedirect = (): string | null => {
  const storedPath = getPostOAuthRedirect();
  clearPostOAuthRedirect();
  return storedPath;
};
